import React, { useState } from 'react'

import AgentSelect from './AgentSelect'

import { Agent } from '~/auth/store/auth.reducer'
import { CareMockDB } from '~/mockDB'
import { ContentModal } from '~/ui/components'

export interface LoginMockProps {
  isOpen: boolean
  onClose?: () => void
  authenticateDev?: (agent: Agent) => Promise<void>
}

const LoginMock: React.FC<LoginMockProps> = ({
  isOpen = false,
  onClose = () => ({}),
  authenticateDev,
}) => {
  const [agentNameId, setAgentNameId] = useState('')

  function onClosing() {
    onClose()
  }

  function onSelectingAgent(agentNameId: string) {
    setAgentNameId(agentNameId)
  }

  function onNextAction() {
    onClose()

    if (agentNameId) {
      const agentInfoMock = CareMockDB[agentNameId]

      if (agentInfoMock.mockType === 'AgentInfoMock') {
        authenticateDev?.({
          aud: '',
          familyName: agentInfoMock.familyName,
          givenName: agentInfoMock.givenName,
          scope: '',
          sub: agentInfoMock.sub,
        })
      }
    }
  }

  return (
    <ContentModal
      dataHook="login-modal"
      isOpen={isOpen}
      onClose={onClosing}
      title="Seleccionar Agente"
      onNextStep={onNextAction}
      confirmButtonDisabled={false}
      confirmButtonTxt="log in"
    >
      <AgentSelect onChangeAgent={onSelectingAgent} />
    </ContentModal>
  )
}

export default LoginMock
